<template>
  <div class="car_list_classic_descr mr-0">
    <div class="car_list_cont">
      <div class="car-title">{{ infocar.nome }}</div>
      <div class="car-descr">
        <div class="car_container">
          <div class="img_car_classic">
            <img
              src="../../../images/project-img/ico-classic-grey.png"
              alt="auto icon"
              width="140px"
            />
          </div>
          <div class="row_descr row_descr_2">
            <div>
              <div class="single_row">
                <span class="label-bold">Cilindrata:</span>
                <span class="text-bold">{{ infocar.cilindrata }}</span>
              </div>
              <div class="single_row">
                <span>In commercio dal</span>
                <span class="text-bold">{{ infocar.annoInizio || infocar.inizioVendita }}</span>
                <span>al</span>
                <span class="text-bold">{{ infocar.annoFine || infocar.fineVendita }}</span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassicCarContainer',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ClassicCarContainer.vue